module.exports = "/_next/static/images/organization1-e87803a6dec27e18671dd487acedd051.jpg";